import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ApiResponse } from "../../../types/apiResponse";
import type { QuoteConceptPayload } from "../types";
import { addQuoteConcept } from "../apis/addQuoteConcept";

export const useAddQuoteConcept = () => {
    const queryClient = useQueryClient();

    return useMutation<ApiResponse, Error, QuoteConceptPayload>({
        mutationFn: addQuoteConcept,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["quotes"] });
        },
    });
};
